import instance from "../../utils/axios";

const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) =>
    formData.append(k, v ?? "")
  );
  return formData;
};

// SAVE
export const saveProgramVideo = async (payload) => {
  const res = await instance.post(
    "/churches/programs/programvideos/save",
    toFormData(payload)
  );
  return res.data;
};

// UPDATE
export const updateProgramVideo = async (payload) => {
  const res = await instance.post(
    "/churches/programs/programvideos/update",
    toFormData(payload)
  );
  return res.data;
};

// DELETE
export const deleteProgramVideo = async (payload) => {
  const res = await instance.post(
    "/churches/programs/programvideos/delete",
    toFormData(payload)
  );
  return res.data;
};

// READ
export const readProgramVideos = async (payload) => {
  const res = await instance.post(
    "/churches/programs/programvideos/read",
    toFormData(payload)
  );
  return res.data;
};
